import clsx from 'clsx'

import { SimpleSpinner, XIcon, UnstyledButton } from '@buffer-mono/popcorn'

import type { Attachment } from '../FeedbackWidget.types'

import styles from './AttachmentPreview.module.css'

import type { JSX } from 'react'

interface AttachmentPreviewProps {
  attachment: Attachment
  onRemove: (id: string) => void
}

export function AttachmentPreview({
  attachment,
  onRemove,
}: AttachmentPreviewProps): JSX.Element {
  return (
    <div
      className={clsx(
        styles.attachmentItem,
        attachment.isUploading && styles.attachmentUploading,
        attachment.uploadError && styles.attachmentError,
      )}
    >
      {attachment.type === 'image' ? (
        <img
          src={attachment.previewUrl}
          alt={attachment.file.name}
          className={styles.attachmentPreview}
        />
      ) : (
        <video
          src={attachment.previewUrl}
          className={styles.attachmentPreview}
          preload="metadata"
          muted
          aria-label={attachment.file.name}
        />
      )}
      {attachment.isUploading && (
        <div className={styles.uploadingOverlay}>
          <SimpleSpinner color="brand" />
        </div>
      )}
      <UnstyledButton
        aria-label={`Remove ${attachment.file.name}`}
        className={styles.removeAttachment}
        onClick={(): void => onRemove(attachment.id)}
      >
        <XIcon size={12} />
      </UnstyledButton>
    </div>
  )
}
